import {
  HomeOutlined, 
  Dashboard, 
  AssessmentOutlined, 
  FlightOutlined, 
  Airlines,
  ViewKanbanOutlined, 
  HelpOutline, 
  ViewTimeline, 
  BarChartOutlined,
  PieChartOutlineOutlined, 
  StackedLineChartOutlined, 
  AccessTime, 
  Report,
  ViewDay, 
  DonutSmallOutlined, 
  DonutLargeOutlined, 
  BubbleChartOutlined,
  LineAxis, 
  Analytics, 
  InsertChart, 
  ViewAgenda, 
  WaterfallChart, 
  AutoGraph,
  Contacts, 
  Person, 
  AirlineSeatReclineNormal, 
  Route, 
  AltRoute, 
  ModeOfTravel,
  TrendingUp, 
  Details, 
  QueryStats, 
  ChangeHistory, 
  History, 
  MoreTime,
  AirplaneTicket, 
  FlightTakeoff, 
  Landscape, 
  Flag, 
  Checklist,
  HowToReg, 
  Attribution, 
  VerifiedUser, 
  Stars, 
  AddShoppingCart,
  ShoppingCart, 
  Receipt, 
  AttachMoney, 
  MonetizationOn, 
  PermDataSetting,
  PersonPin, 
  ConnectingAirports, 
  GraphicEq, 
  BedtimeOff, 
  NoteAlt,
  Timeline, 
  Summarize, 
  Webhook, 
  Equalizer, 
  ShowChart, 
  Insights, 
  LegendToggle,
  PsychologyAlt, 
  MultilineChart, 
  FileCopy, 
  Compare, 
  DonutLarge, 
  BubbleChart,
  DataExploration, 
  CalendarMonth, 
  TransferWithinAStation, 
  AccountBalanceWallet,
  Timelapse, 
  PriceChange, 
  LocalShipping, 
  Category, 
  Inventory, 
  LocalMall,
  ProductionQuantityLimits,
  TypeSpecimen, 
  AlignHorizontalLeft,
  CleaningServices, 
  EventBusy, 
  EmojiFoodBeverage, 
  Group, 
  GroupAdd, 
  HelpCenter,
  Cases, 
  Map, 
  CircleNotifications, 
  EditNotifications, 
  Loupe, 
  WatchLater,
  AlignVerticalTop, 
  Assessment, 
  IncompleteCircle, 
  PermContactCalendar,
  NotificationImportant, 
  Toll, 
  Approval, 
  TravelExplore, 
  MilitaryTech,
  CardTravel, 
  AirportShuttle, 
  Adjust, 
  Anchor, 
  Attractions, 
  CardMembership,
  CloudUpload, 
  ControlCamera, 
  Timer, 
  Event, 
  EmojiEvents, 
  Polyline,
  SpaceDashboard, 
  DashboardCustomize, 
  MenuOpen, 
  HistoryToggleOff,
  EditLocation, 
  Task, 
  AddTask, 
  AddHome,
  DynamicForm,
  MenuBook,
  Construction,
  LocationSearching,
  School,
  Villa,
  Factory, 
  WbShade,
  Foundation,
  RunningWithErrors,
  CodeOff,
  TableView,
  NextPlan,
  CloudSync,
  Dataset,
} from "@mui/icons-material";


const NavItems = () => {
    const navItems = [
        {
            text: "Main",
            icon: <HomeOutlined />,
            path: "main",
            group: "dashboard",
            roles: [],
        },        
        {
            text: "OTP",
            icon: <AccessTime />,
            path: "otp",
            group: "dashboard",
            roles: [],
        },
        {
            text: "ML Analytics",
            icon: <PsychologyAlt />,
            path: "ml-analytics",
            group: "dashboard",
            roles: [],
        },        
        {
            text: "Load Factor",
            icon: <Webhook />,
            path: "loadfactor",
            group: "dashboard",
            roles: [],
        },
        {
            text: "Shift Reports",
            icon: <Report />,
            path: "shiftreports",
            group: "dashboard",
            roles: [],
        },
        {
            text: "Crew Shuttles",
            icon: <AirportShuttle />,
            path: "crewshuttles",
            group: "dashboard",
            roles: [],
        },
        {
            text: "Flight",
            icon: null,
            path: null,
            group: "flight",
            roles: [],
        },
        {
            text: "Dashboard",
            icon: <Dashboard />,
            path: "dashboard",
            group: "flight",
            roles: [],
        },
        {
            text: "Flight Schedule",
            icon: <FlightOutlined />,
            path: "flightschedule",
            group: "flight",
            roles: [],
        },
        {
            text: "Flight View",
            icon: <ViewDay />,
            path: "flightview",
            group: "flight",
            roles: [],
        },
        {
            text: "Flight Map",
            icon: <Map />,
            path: "flightmap",
            group: "flight",
            roles: [],
        },
        {
            text: "Flight Gantt Chart",
            icon: <Timeline />,
            path: "flightganttchart",
            group: "flight",
            roles: [],
        },
        {
            text: "Station Schedule",
            icon: <Airlines />,
            path: "stationschedule",
            group: "flight",
            roles: [],
        },
        {
            text: "Flight Slots",
            icon: <ViewAgenda />,
            path: "flightslots",
            group: "flight",
            roles: [],
        },
        {
            text: "SSIM",
            icon: <Summarize />,
            path: "ssim",
            group: "flight",
            roles: [],
        },
        {
            text: "Flight Compare",
            icon: <Compare />,
            path: "flightcompare",
            group: "flight",
            roles: []
        },
        {
            text: "Flight Charts",
            icon: <AssessmentOutlined />,
            group: "flight",
            subItems: [
                {
                    text: "Flight",
                    icon: <BarChartOutlined />,
                    path: "flight",
                    group: "flight",
                    roles: []
                },
                {
                    text: "Daily Flight",
                    icon: <StackedLineChartOutlined />,
                    path: "dailyflight",
                    group: "flight",
                    roles: []
                },
                {
                    text: "Cancelled Flight",
                    icon: <BarChartOutlined />,
                    path: "cancelledflight",
                    group: "flight",
                    roles: []
                },
                {
                    text: "TAT",
                    icon: <BubbleChartOutlined />,
                    path: "tat",
                    group: "flight",
                    roles: []
                },
                {
                    text: "TAT Diff",
                    icon: <DataExploration />,
                    path: "tatdiff",
                    group: "flight",
                    roles: []
                },
                {
                    text: "Taxi Out",
                    icon: <DonutSmallOutlined />,
                    path: "taxiout",
                    group: "flight",
                    roles: []
                },
                {
                    text: "Taxi In",
                    icon: <DonutLargeOutlined />,
                    path: "taxiin",
                    group: "flight",
                    roles: []
                },
                {
                    text: "Air Time",
                    icon: <BubbleChart />,
                    path: "airtime",
                    group: "flight",
                    roles: []
                },
                {
                    text: "Block Time",
                    icon: <DonutLarge />,
                    path: "blockminutesper1flt",
                    group: "flight",
                    roles: []
                },
                {
                    text: "Block Time Diff",
                    icon: <PieChartOutlineOutlined />,
                    path: "btdiff",
                    group: "flight",
                    roles: []
                },
                {
                    text: "Total Block Hrs",
                    icon: <DonutLarge />,
                    path: "blockhours",
                    group: "flight",
                    roles: []
                },
            ],
        },
        {
            text: "Dispatcher Checklists",
            icon: <Checklist />,
            path: "dispatcherchecklists",
            group: "flight",
            roles: [],
        },
        {
            text: "Aircraft Routes",
            icon: <Polyline />,
            path: "aircraftroutes",
            group: "flight",
            roles: [],
        },
        {
            text: "Crew Composition",
            icon: <GroupAdd />,
            path: "crewcomposition",
            group: "flight",
            roles: [],
        },
        {
            text: "Crew Pairings",
            icon: <ModeOfTravel />,
            path: "crewpairings",
            group: "flight",
            roles: []
        },
        {
            text: "Pairing Charts",
            icon: <InsertChart />,
            group: "flight",
            subItems: [
                {
                    text: "Pairing",
                    icon: <ShowChart />,
                    path: "crewpairingscount",
                    group: "flight",
                    roles: []
                },
                {
                    text: "Daily Pairing",
                    icon: <Insights />,
                    path: "dailycrewpairings",
                    group: "flight",
                    roles: []
                },
            ],
        },
        {
            text: "Sched",
            icon: null,
            path: null,
            group: "scheduling",
            roles: [],
        },
        {
            text: "Schedule Seasons",
            icon: <CalendarMonth />,
            path: "schedule-seasons",
            group: "scheduling",
            roles: [],
        },
        {
            text: "Schedule Timetable",
            icon: <TableView />,
            path: "scheduletimetable",
            group: "scheduling",
            roles: [],
        },
        {
            text: "Schedule Planner",
            icon: <ViewTimeline />,
            path: "scheduleplanner",
            group: "scheduling",
            roles: [],
        },
        {
            text: "Network Planner",
            icon: <Map />,
            path: "networkplanner",
            group: "scheduling",
            roles: [],
        },
        {
            text: "Rotation Builder",
            icon: <Construction />,
            path: "rotationbuilder",
            group: "scheduling",
            roles: [],
        },
        {
            text: "Station View",
            icon: <LocationSearching />,
            path: "stationview",
            group: "scheduling",
            roles: [],
        },
        {
            text: "TAT",
            icon: null,
            path: null,
            group: "tat",
            roles: [],
        },
        {
            text: "TAT Dashboard",
            icon: <SpaceDashboard />,
            path: "tatdashboard",
            group: "tat",
            roles: [],
        },
        {
            text: "TAT Controller",
            icon: <ControlCamera />,
            path: "tatcontroller",
            group: "tat",
            roles: [],
        },
        {
            text: "TAT Instances",
            icon: <Timer />,
            path: "tatinstances",
            group: "tat",
            roles: [],
        },
        {
            text: "TAT Templates",
            icon: <Event />,
            path: "tattemplates",
            group: "tat",
            roles: [],
        },
        {
            text: "Crew",
            icon: null,
            path: null,
            group: "crew",
            roles: [],
        },
        {
            text: "Crew Board",
            icon: <DashboardCustomize />,
            path: "crewdashboard",
            group: "crew",
            roles: [],
        },
        {
            text: "Crew Members",
            icon: <Contacts />,
            path: "crewmembers",
            group: "crew",
            roles: [],
        },
        {
            text: "Non Crew Members",
            icon: <Person />,
            path: "noncrewmembers",
            group: "crew",
            roles: [],
        },
        {
            text: "Jump Seaters",
            icon: <AirlineSeatReclineNormal />,
            path: "jumpseaters",
            group: "crew",
            roles: [],
        },
        {
            text: "Deadheadings",
            icon: <TransferWithinAStation />,
            path: "deadheadings",
            group: "crew",
            roles: [],
        },
        {
            text: "Crew Routes",
            icon: <Route />,
            path: "crewroutes",
            group: "crew",
            roles: [],
        },
        {
            text: "Unfinalized Crew Routes",
            icon: <IncompleteCircle />,
            path: "unfinalizedcrewroutes",
            group: "crew",
            roles: [],
        },
        {
            text: "Route Charts",
            icon: <Assessment />,
            group: "crew",
            subItems: [
                {
                    text: "Route",
                    icon: <LineAxis />,
                    path: "crewroutescount",
                    group: "crew",
                    roles: []
                },
                {
                    text: "Daily Route",
                    icon: <BarChartOutlined />,
                    path: "dailycrewroutes",
                    group: "crew",
                    roles: []
                },
            ],
        },
        {
            text: "Crew Pending Notifications",
            icon: <NotificationImportant />,
            path: "crewpendingnotifications",
            group: "crew",
            roles: [],
        },
        {
            text: "Top Buddy Flying",
            icon: <AlignVerticalTop />,
            path: "topbuddyflying",
            group: "crew",
            roles: [],
        },
        {
            text: "Roster Analytics",
            icon: <QueryStats />,
            path: "rosteranalytics",
            group: "crew",
            roles: [],
        },
        {
            text: "Roster Accumulates",
            icon: <Loupe />,
            path: "rosteraccumulates",
            group: "crew",
            roles: [],
        },
        {
            text: "OTP by Crew",
            icon: <WatchLater />,
            path: "otpbycrew",
            group: "crew",
            roles: [],
        },
        {
            text: "Annual Leaves",
            icon: <BedtimeOff />,
            path: "annualleaves",
            group: "crew",
            roles: [],
        },
        {
            text: "Crew Requests",
            icon: <NoteAlt />,
            path: "crewrequests",
            group: "crew",
            roles: [],
        },
        {
            text: "Roster Details",
            icon: <Details />,
            path: "rosterdetails",
            group: "crew",
            roles: [],
        },
        {
            text: "Crew Gantt Chart",
            icon: <ViewTimeline />,
            path: "crewganttchart",
            group: "crew",
            roles: [],
        },
        {
            text: "Crew Charts",
            icon: <Analytics />,
            group: "crew",
            subItems: [
                {
                    text: "Crew Members",
                    icon: <MultilineChart />,
                    path: "crewmemberscount",
                    group: "crew",
                    roles: []
                },
                {
                    text: "Flying Crews",
                    icon: <TrendingUp />,
                    path: "flyingcrewcount",
                    group: "crew",
                    roles: []
                },
                {
                    text: "DHD Count",
                    icon: <ShowChart />,
                    path: "deadheadingschart",
                    group: "crew",
                    roles: []
                },
                {
                    text: "Non Crew List",
                    icon: <LegendToggle />,
                    path: "noncrewlistchart",
                    group: "crew",
                    roles: []
                },
                {
                    text: "Crew Block Hours",
                    icon: <WaterfallChart />,
                    path: "crewblockhours",
                    group: "crew",
                    roles: []
                },
                {
                    text: "Crew Total Hours",
                    icon: <AutoGraph />,
                    path: "crewtotalhours",
                    group: "crew",
                    roles: []
                },
                {
                    text: "Crew Roster Details",
                    icon: <DonutLarge />,
                    path: "crewrosterdetails",
                    group: "crew",
                    roles: []
                },
            ],
        },
        {
            text: "Job 255",
            icon: null,
            path: null,
            group: "job255",
            roles: [],
        },
        {
            text: "Crew Routes (Job 255)",
            icon: <AltRoute />,
            path: "job255crewroutes",
            group: "job255",
            roles: [],
        },
        {
            text: "Charts (Job 255)",
            icon: <Equalizer />,
            group: "job255",
            subItems: [
                {
                    text: "Route (Job 255)",
                    icon: <ShowChart />,
                    path: "job255crewroutescount",
                    group: "job255",
                    roles: []
                },
                {
                    text: "Daily Route (Job 255)",
                    icon: <Insights />,
                    path: "job255dailycrewroutes",
                    group: "job255",
                    roles: []
                },
                {
                    text: "Crew Block Hours (Job 255)",
                    icon: <MultilineChart />,
                    path: "job255crewblockhours",
                    group: "job255",
                    roles: []
                },
            ],
        },
        {
            text: "Payroll",
            icon: null,
            path: null,
            group: "crewpayroll",
            roles: [],
        },
        {
            text: "Crew Payroll",
            icon: <AccountBalanceWallet />,
            path: "crewpayroll",
            group: "crewpayroll",
            roles: [],
        },
        {
            text: "Job 147",
            icon: <PriceChange />,
            path: "job147crewpayroll",
            group: "crewpayroll",
            roles: [],
        },
        {
            text: "Crew Performances",
            icon: <EmojiEvents />,
            path: "crewperformances",
            group: "crewpayroll",
            roles: [],
        },
        {
            text: "Travel Authorization Form",
            icon: <TravelExplore />,
            path: "travelauthorizationforms",
            group: "crewpayroll",
            roles: [],
        },
        {
            text: "Travel Allowance Entry",
            icon: <DynamicForm />,
            path: "travelallowanceentries",
            group: "crewpayroll",
            roles: [],
        },
        {
            text: "Income Adjustments",
            icon: <Adjust />,
            path: "incomeadjustments",
            group: "crewpayroll",
            roles: [],
        },
        {
            text: "Fixed Block Times",
            icon: <Timelapse />,
            path: "fixedblocktimes",
            group: "crewpayroll",
            roles: [],
        },
        {
            text: "Cost Items",
            icon: <Toll />,
            path: "costitems",
            group: "crewpayroll",
            roles: [],
        },{
            text: "Travel Allowances",
            icon: <CardTravel />,
            path: "travelallowances",
            group: "crewpayroll",
            roles: [],
        },
        {
            text: "Contributions",
            icon: <Anchor />,
            path: "contributions",
            group: "crewpayroll",
            roles: [],
        },
        {
            text: "Contribution Types",
            icon: <Attractions />,
            path: "contributiontypes",
            group: "crewpayroll",
            roles: [],
        },        
        {
            text: "Sales",
            icon: null,
            path: null,
            group: "sales",
            roles: [],
        },
        {
            text: "Sales Charts",
            icon: <GraphicEq />,
            path: "saleschart",
            group: "sales",
            roles: [],
        },
        {
            text: "Crew List",
            icon: <PersonPin />,
            path: "crewlist",
            group: "sales",
            roles: [],
        },
        {
            text: "Flight List",
            icon: <ConnectingAirports />,
            path: "flightlist",
            group: "sales",
            roles: [],
        },
        {
            text: "Invoices",
            icon: <Receipt />,
            path: "invoices",
            group: "sales",
            roles: [],
        },
        {
            text: "Inventory",
            icon: <Inventory />,
            path: "inventory",
            group: "sales",
            roles: [],
        },
        {
            text: "Product Sales",
            icon: <AttachMoney />,
            path: "productsales",
            group: "sales",
            roles: [],
        },
        {
            text: "Crew Sales",
            icon: <MonetizationOn />,
            path: "crewmembersales",
            group: "sales",
            roles: [],
        },
        {
            text: "Inventory by Date",
            icon: <ShoppingCart />,
            path: "productinventorybydate",
            group: "sales",
            roles: [],
        },
        {
            text: "Inventory by Type",
            icon: <ProductionQuantityLimits />,
            path: "productinventorybysectortype",
            group: "sales",
            roles: [],
        },
        {
            text: "Inventory Summary",
            icon: <LocalMall />,
            path: "productinventorysummary",
            group: "sales",
            roles: [],
        },
        {
            text: "Duplicate Flights",
            icon: <FileCopy />,
            path: "duplicateinvoicedflights",
            group: "sales",
            roles: [],
        },
        {
            text: "HRMS",
            icon: null,
            path: null,
            group: "hrms",
            roles: [],
        },
        {
            text: "Employee Stats",
            icon: <Insights />,
            path: "employeestats",
            group: "hrms",
            roles: [],
        },
        {
            text: "Employees",
            icon: <Group />,
            path: "employees",
            group: "hrms",
            roles: [],
        },
        {
            text: "Timekeeping",
            icon: <HistoryToggleOff />,
            path: "timekeeping",
            group: "hrms",
            roles: []
        },
        {
            text: "TMS",
            icon: null,
            path: null,
            group: "tms",
            roles: [],
        },
        {
            text: "Training Courses",
            icon: <Cases />,
            path: "trainingcourses",
            group: "tms",
            roles: []
        },      
        {
            text: "Training Sessions",
            icon: <School />,
            path: "trainingsessions",
            group: "tms",
            roles: [],
        },
        {
            text: "Training Planner",
            icon: <NextPlan />,
            path: "trainingplanner",
            group: "tms",
            roles: [],
        },
        {
            text: "Training Subjects",
            icon: <MenuBook />,
            path: "trainingsubjects",
            group: "tms",
            roles: [],
        },        
        {
            text: "Competency Frameworks",
            icon: <Foundation />,
            path: "competencyframeworks",
            group: "tms",
            roles: [],
        },
        {
            text: "Notice",
            icon: null,
            path: null,
            group: "notice",
            roles: [],
        },
        {
            text: "Notifications",
            icon: <CircleNotifications />,
            path: "notifications",
            group: "notice",
            roles: []
        },
        {
            text: "Notice Board",
            icon: <EditNotifications />,
            path: "noticeboard",
            group: "notice",
            roles: []
        },
        {
            text: "CMS",
            icon: null,
            path: null,
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Home Page Editor",
            icon: <AddHome />,
            path: "homepageeditor",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "FAQs",
            icon: <HelpOutline />,
            path: "faqs",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Contacts",
            icon: <PermContactCalendar />,
            path: "contacts",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Todos",
            icon: <AddTask />,
            path: "todos",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Shifts",
            icon: <Task />,
            path: "shifts",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Holidays",
            icon: <EventBusy />,
            path: "holidays",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Product Categories",
            icon: <Category />,
            path: "productcategories",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Products",
            icon: <AddShoppingCart />,
            path: "products",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Suppliers",
            icon: <LocalShipping />,
            path: "suppliers",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Supply Standards",
            icon: <EmojiFoodBeverage />,
            path: "supplystandards",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Divisions",
            icon: <Villa />,
            path: "divisions",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Departments",
            icon: <Factory />,
            path: "departments",
            group: "cms",
            roles: ['admin'],
        },        
        {
            text: "Dept Units",
            icon: <WbShade />,
            path: "deptunits",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Job Titles",
            icon: <Approval />,
            path: "jobtitles",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Job Grades",
            icon: <MilitaryTech />,
            path: "jobgrades",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Ranks",
            icon: <Stars />,
            path: "ranks",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Crew Complements",
            icon: <Group />,
            path: "crewcomplements",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "AC Types",
            icon: <AirplaneTicket />,
            path: "actypes",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Aircrafts",
            icon: <FlightTakeoff />,
            path: "aircrafts",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Transport Places",
            icon: <EditLocation />,
            path: "transportplaces",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Airports",
            icon: <Landscape />,
            path: "airports",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Airport Pairs",
            icon: <AlignHorizontalLeft />,
            path: "airportpairs",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Countries",
            icon: <Flag />,
            path: "countries",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Delay Codes",
            icon: <MoreTime />,
            path: "delaycodes",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Crew Schedule Codes",
            icon: <CodeOff />,
            path: "crewschedulecodes",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Crew Schedule Code Categories",
            icon: <TypeSpecimen />,
            path: "crewschedulecodecategories",
            group: "cms",
            roles: ['admin'],
        },        
        {
            text: "Checklist Items",
            icon: <Checklist />,
            path: "checklistitems",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Collection Defs",
            icon: <Dataset />,
            path: "collections",
            group: "cms",
            roles: ['admin'],
        },
        {
            text: "Audit",
            icon: null,
            path: null,
            group: "audit",
            roles: ['admin', 'moderator'],
        },
        {
            text: "Flight Logs",
            icon: <ChangeHistory />,
            path: "flightschedulechanges",
            group: "audit",
            roles: ['admin', 'moderator'],
        },
        {
            text: "Crew Logs",
            icon: <History />,
            path: "crewschedulechanges",
            group: "audit",
            roles: ['admin', 'moderator'],
        },
        {
            text: "Anomaly Detection",
            icon: <RunningWithErrors />,
            path: "anomalydetection",
            group: "audit",
            roles: ['admin', 'moderator'],
        },
        {
            text: "Auth",
            icon: null,
            path: null,
            group: "auth",
            roles: ['admin', 'moderator'],
        },
        {
            text: "Users",
            icon: <VerifiedUser />,
            path: "users",
            group: "auth",
            roles: ['admin', 'moderator'],
        },
        {
            text: "Permissions",
            icon: <Attribution />,
            path: "permissions",
            group: "auth",
            roles: ['admin'],
        },
        {
            text: "Roles",
            icon: <HowToReg />,
            path: "roles",
            group: "auth",
            roles: ['admin'],
        },
        {
            text: "Menus",
            icon: <MenuOpen />,
            path: "menus",
            group: "auth",
            roles: ['admin'],
        },
        {
            text: "Params",
            icon: <PermDataSetting />,
            path: "params",
            group: "auth",
            roles: ['admin'],
        },        
        {
            text: "License Generator",
            icon: <CardMembership />,
            path: "generatelicense",
            group: "auth",
            roles: ['admin'],
        },        
        {
            text: "Purge Data",
            icon: <CleaningServices />,
            path: "purgedata",
            group: "auth",
            roles: ['admin'],
        },
        {
            text: "Data Importer",
            icon: <CloudUpload />,
            path: "dataimporter",
            group: "auth",
            roles: ['admin'],
        },
        {
            text: "Data Requests",
            icon: <CloudSync />,
            path: "datarequests",
            group: "auth",
            roles: ['admin'],
        },
        {
            text: "Page",
            icon: null,
            path: null,
            group: "page",
            roles: [],
        },
        {
            text: "Kanban Board",
            icon: <ViewKanbanOutlined />,
            path: "kanbanboard",
            group: "page",
            roles: []
        },
        {
            text: "FAQ",
            icon: <HelpCenter />,
            path: "faq",
            group: "page",
            roles: []
        },
    ];

    return navItems;
};

export default NavItems;
